import { render, staticRenderFns } from "./FormAccountPassword.vue?vue&type=template&id=56ea6f0b&scoped=true&"
import script from "./FormAccountPassword.vue?vue&type=script&lang=ts&"
export * from "./FormAccountPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea6f0b",
  null
  
)

export default component.exports